export default "/_next/static/media/jk.9735e5faa0aebcf40e6155abebac86ab.jpeg";